import { Component } from '@angular/core';

@Component({
    selector: 'app-not-found',
    template: require('./app-not-found.component.html'),
    styles: [require('./app-not-found.component.scss')]
})
export class AppNotFoundComponent {
    reload() {
        window.location.reload(true);
    }
}
